import { DEFAULT_TIME } from '@shared/config/constants'

export const APP = {
  PARTNER_WIDGET: {
    env: import.meta.env.VITE_APP_PARTNERWIDGET_ENV,
    group: 'partnerWidget',
    name: 'partnerWidget',
  },
}

export const EVENT_PARTNER_WIDGET = {
  DISPLAYED: 'ovp-partner-widget-displayed',
  GOTO_SANITAS: 'ovp-partner-widget-goto-sanitas',
  PAGE_VIEWED: 'ovp-partner-widget-page-viewed',
}

export const SOURCE = {
  PARTNER_WIDGET: 'PartnerWidget',
}

export const CHANNEL = {
  PARTNER_WIDGET: 'PARTNERWIDGET',
}

// dynamic components
export const SCREEN = {
  BUNDLE: 'PartnerBundle',
  DETAIL: 'PartnerDetail',
  ENTRY: 'PartnerEntry',
  ERROR: 'PartnerError',
}

export const BOOLEAN_CONFIG_KEYS = [
  'animatedEntryLabelsOnClick',
  'animatedEntryLabelsOnlyOnce',
  'badge',
  'logo',
  'openInSameWindow',
  'skipEntryPage',
  'skipPackagesOverview',
  'showPackagesOverviewInfoIcon',
]

export const CATEGORY_ADDITIONAL = 'ADDITIONAL'
export const CATEGORY_FURTHER_ADDITIONAL = 'FURTHER_ADDITIONAL'

export const PARTNER_WIDGET_RESTART_TIMEOUT = 15 * DEFAULT_TIME
